export default "__VITE_ASSET__gaAN__Z2__"